/** 与 flexible.js 窄屏阈值对齐：≤900 视为移动端 */
export const MOBILE_MAX_WIDTH = 900

export function viewportWidth() {
	if (typeof window === 'undefined') return 1920
	const vv = window.visualViewport && window.visualViewport.width
	const cssW = document.documentElement && document.documentElement.clientWidth
	const inner = window.innerWidth
	const nums = [vv, cssW, inner].filter(function(n) {
		return typeof n === 'number' && n > 0
	})
	return nums.length ? Math.min.apply(null, nums) : 1920
}

export function detectIsMobile() {
	if (typeof window === 'undefined') return false
	const w = viewportWidth()
	const mq = window.matchMedia
	const narrow = (mq && mq('(max-width: 900px)').matches) || w <= MOBILE_MAX_WIDTH
	const coarse = mq && mq('(pointer: coarse)').matches
	const hoverNone = mq && mq('(hover: none)').matches
	const ua = String((typeof navigator !== 'undefined' && (navigator.userAgent || navigator.vendor)) || '')
	const phoneUA = /iPhone|iPod|Android.+Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)
	let screenMin = 0
	if (window.screen) {
		const sw = Number(window.screen.width) || 0
		const sh = Number(window.screen.height) || 0
		if (sw && sh) screenMin = Math.min(sw, sh)
	}
	// iPhone Plus/Max 的 CSS 点约 428–430；flexible 把 initial-scale 设成 1/dpr 后
	// layout 宽度会到 1284+，旧阈值 1180 会把这些手机误判成桌面端。
	const phoneScreen = screenMin > 0 && screenMin <= 520
	return !!(narrow || phoneUA || phoneScreen || ((coarse || hoverNone) && w <= 1400))
}

/** 同步 html 标记并锁定 rem，避免 390 竖屏把 1920 稿缩成 3px 字 */
export function applyMobileViewport() {
	const mobile = detectIsMobile()
	if (typeof document === 'undefined') return mobile
	const el = document.documentElement
	if (mobile) {
		el.classList.add('is-mobile-viewport')
		el.style.fontSize = '192px'
	} else {
		el.classList.remove('is-mobile-viewport')
		if (window.lib && window.lib.flexible && typeof window.lib.flexible.refreshRem === 'function') {
			window.lib.flexible.refreshRem()
		}
	}
	return mobile
}
